import { SearchRounded } from "@mui/icons-material";
import { Autocomplete, InputAdornment, TextField as MuiTextField, styled } from "@mui/material";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { greyEnabled, purple } from "../../../theme/colors";
import useNavOptions, { DrawerOption } from "./use_nav_options";

const TextField = styled(MuiTextField)(() => ({
  "& .MuiOutlinedInput-root": {
    backgroundColor: "#FFFFFF",
    borderRadius: 8,
    "& fieldset": { borderColor: "#ABA0AB" },
    "&:hover fieldset": { borderColor: purple },
    "&.Mui-focused fieldset": { borderColor: purple, borderWidth: 2 },
  },
}));

export default function NavSearch() {
  const navigate = useNavigate();
  const navOptions = useNavOptions();
  const [inputValue, setInputValue] = useState("");

  // Logout is a real destructive action, not a page — excluded so it can
  // never be triggered by picking a search result.
  const searchableOptions = (navOptions || []).filter((option) => option.route !== "/logout");

  const handleSelect = (option: DrawerOption | null) => {
    if (!option) return;
    navigate(option.route);
    setInputValue("");
  };

  return (
    <Autocomplete
      size="small"
      options={searchableOptions}
      getOptionLabel={(option) => option.label}
      inputValue={inputValue}
      onInputChange={(_, value) => setInputValue(value)}
      onChange={(_, selected) => handleSelect(selected)}
      value={null}
      blurOnSelect
      clearOnBlur
      componentsProps={{
        paper: {
          elevation: 0,
          sx: {
            mt: 0.5,
            borderRadius: 2,
            border: "1px solid #ECECEC",
            boxShadow: "0px 12px 28px -8px rgba(27, 0, 27, 0.18)",
          },
        },
      }}
      renderOption={(props, option) => (
        <li {...props} key={option.route}>
          {option.label}
        </li>
      )}
      sx={{ width: { xs: 140, sm: 280 } }}
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder="Search menu"
          InputProps={{
            ...params.InputProps,
            startAdornment: (
              <InputAdornment position="start">
                <SearchRounded sx={{ color: greyEnabled, fontSize: 20 }} />
              </InputAdornment>
            ),
          }}
        />
      )}
    />
  );
}
